import React from 'react';
import classnames from 'classnames';
import classes from './empty-list.scss';
export const EmptyList = props => {
  const {
    title,
    subtitle = '',
    additionalContent,
    wrapperClassName = '',
    isScalable = false,
    innerClassName = ''
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    className: classnames({
      [classes.wrapper]: !isScalable,
      [classes.scalable]: isScalable
    }, wrapperClassName)
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.content, innerClassName)
  }, /*#__PURE__*/React.createElement("h3", {
    className: classes.title
  }, title), subtitle && /*#__PURE__*/React.createElement("p", {
    className: classes.subtitle
  }, subtitle), additionalContent && /*#__PURE__*/React.createElement("div", {
    className: classes.wrapperAdditionalContent
  }, additionalContent)));
};